import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Razorpay from "./RazorPay/Razorpay";
import EaseBuzzPayment from "./Easebuzz/EasebuzzPayment"
import Login from "../src/User/LoginPage/Login";
import Camps from "../src/components/Pages/Camps/Camps";
import Isbc from "../src/components/Pages/ISBC/ISBC";
import RegisterForm from "../src/components/Pages/RegisterForm/RegisterForm.js";
// import RegisteredPlayers from "./components/Pages/RegisterdPlayers/RegisteredPlayers";
import PlayerProfile from "./components/RegisterdPlayers/PlayerProfile/PlayerProfile";
import PlayersList from "./components/RegisterdPlayers/PlayersList/PlayersList";
import SunilBabu from "./components/Pages/AboutUS/M-profiles/SunilBabuProfile";
import DilipVengsarkar from "./components/Pages/AboutUS/M-profiles/Dilip";
import CategoryCamps from "./components/Pages/Camps/CategoryDetail/CategoryDetail";
import EditProfile from "./User/EditProfile/EditProfile";
import Home2 from "./components/Home2";
import MainNav from "../src/components/Nav/MainNav"
import About from "../src/components/Pages/AboutUS/About";
import Nav2 from "./components/Nav/MobileNav";
import Footer from "../src/components/Footer/Footer";
import TermsAndConditions from "./Policys/Terms/TermsAndConditions";
import PrivacyAndPolicy from "./Policys/Terms/PrivacyAndPolicy";
import RefundPolicy from "./Policys/Terms/RefundPolicy"
import { useLayoutEffect } from "react";
import ISBCintroVideo from "./components/Pages/ISBCintroVideo/ISBCintroVideo";
import CommitteeMembers from "./components/Pages/AboutUS/M-profiles/DetailMember";
import MobilePrivacy from "./Policys/Terms/Privacy-policy-Mobile";
import SSrajamoouli from "./components/Pages/AboutUS/M-profiles/SSrajamouli"
import ChetanSharmaProfile from "./components/Pages/AboutUS/M-profiles/ChetanSharmaDetailProfile.js"

function App() {
  ReactGA.initialize('G-E3BX8Q5K3C');
  useEffect(() => {
    // ReactGA.pageview(window.location.pathname);
    ReactGA.send({ hitType: "pageview", page_view: window.location.pathname,});
  }, []);

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
  };

  // const location = useLocation();

  // const renderNavbar = () => {
  //   if (location.pathname === "/") {
  //     return <Nav />;
  //   } else {
  //     return <Nav2 />;
  //   }
  // };

  return (
    <>
      <div className="App">
        <Wrapper>
          {/* {renderNavbar()} */}
          <MainNav/>

          <Routes>
            <Route path="/Login" element={<Login />} />
            <Route path="/" element={<Home2 />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/camps" element={<Camps />} />
            <Route path="/register-form" element={<RegisterForm />} />
            <Route path="/isbc" element={<Isbc />} />
            <Route path="/registered-players" element={<PlayersList />} />
            <Route path="/Sunil-babu-Kolanpaka" element={<SunilBabu />} />
            <Route path="/dilip-vengsarkar" element={<DilipVengsarkar />} />
            <Route path="/ss-rajamouli" element={<SSrajamoouli/>} />
            <Route path="/Chetan-sharma" element={<ChetanSharmaProfile/>} />
            <Route path="/student/:id" element={<PlayerProfile />} />
            <Route path="/payment/:id" element={<Razorpay />} />
            <Route path="/ease-buzz/:id" element={<EaseBuzzPayment/>} />
            <Route path="/camps-list/:id" element={<CategoryCamps />} />
            <Route path="/edit_profile" element={<EditProfile />} />
            <Route path="/terms&conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
            <Route path="/pricing-and-refund-policy" element={<RefundPolicy />} />
            <Route path="/isbc-intro" element={<ISBCintroVideo />} />
            <Route path="/committee-members/:id" element={<CommitteeMembers />} />
            <Route path="/privacy-policy-isbc" element={<MobilePrivacy/>} />
          </Routes>
          <Footer />
        </Wrapper>
      </div>
    </>
  );
}

export default App;
